<template>
  <div>
    <el-dropdown @command="handleCommand" placement="bottom">
      <span class="el-dropdown-link text">
        <i class="el-icon-user-solid"></i>
      </span>
      <el-dropdown-menu slot="dropdown" class="account-menu">
        <el-dropdown-item icon="el-icon-phone" disabled>{{ user.mobile }}</el-dropdown-item>
        <el-dropdown-item icon="el-icon-lock" command="changePasswd">修改密码</el-dropdown-item>
        <el-dropdown-item
            icon="el-icon-switch-button"
            command="logout"
        >退出登录
        </el-dropdown-item>
      </el-dropdown-menu>
    </el-dropdown>
    <el-dialog title="修改密码" class="change-pwd-dialog" width="600px" :visible.sync="dialogChangePwdFormVisible" :close-on-click-modal="false">
      <el-form :model="changePwdForm" :rules="changePasswdRules" ref="changePwdForm">
        <el-form-item label="原密码" :label-width="formLabelWidth">
          <el-input type="password" v-model="changePwdForm.oldPassword" autocomplete="off" placeholder="若未设置过密码，请留空"></el-input>
        </el-form-item>
        <el-form-item label="新密码" prop="newPassword" :label-width="formLabelWidth">
          <el-input type="password" v-model="changePwdForm.newPassword" autocomplete="off" placeholder="请输入新密码"></el-input>
        </el-form-item>
        <el-form-item label="确认密码" prop="confirmPassword" :label-width="formLabelWidth">
          <el-input type="password" v-model="changePwdForm.confirmPassword" autocomplete="off" placeholder="请输入确认密码" :rules="{required: true, message: '请输入确认密码', trigger: 'blur'}"></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="dialogChangePwdFormVisible = false">取 消</el-button>
        <el-button type="primary" @click="changePwdOk('changePwdForm')">确 定</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import {mapState} from "vuex";
import {apiChangePassword} from "@/utils/api";

export default {
  name: "UserMenu",
  data() {
    return {
      dialogChangePwdFormVisible: false,
      formLabelWidth: "85px",
      changePasswdRules: {
        newPassword: [{required: true, message: '请输入新密码', trigger: 'blur'}],
        confirmPassword: [{required: true, message: '请输入确认密码', trigger: 'blur'}],
      },
      changePwdForm: {
        oldPassword: "",
        newPassword: "",
        confirmPassword: ""
      }
    }
  },
  computed: {
    ...mapState({
      user: (state) => state.user
    })
  },
  methods: {
    handleCommand(command) {
      if (command === "logout") {
        this.$message({
          message: "退出成功",
          type: "success"
        })
        localStorage.clear()
        this.$store.commit('CLEAR_ALL')
        this.$router.replace('/login')
      } else if (command === "changePasswd") {
        this.dialogChangePwdFormVisible = true;
      }
    },
    changePwdOk(formName) {
      this.errors = {};
      this.$refs[formName].validate((valid) => {
        if (valid) {
          if (this.changePwdForm.newPassword !== this.changePwdForm.confirmPassword) {
            this.$message({
              message: '确认密码与新密码不一致',
              type: 'error'
            });
            return;
          }
          apiChangePassword(this.changePwdForm).then(response => {
            if (response.data.code === 0) {
              this.$message({
                message: '密码修改成功',
                type: 'success'
              });
              this.dialogChangePwdFormVisible = false;
              this.resetForm('passForm');
            }else{
              this.$message({
                message: response.data.msg,
                type: 'error'
              })
            }
          });
        } else {
          return false;
        }
      });
    }
  }
}
</script>

<style scoped>

</style>
